const CargoBar = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_CargoSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'cargoSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isShowCargoBar',
            },
            options: {
              containerPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              textColor: {
                type: 'HexColor',
                order: 2,
              },
              priceTextColor: {
                type: 'HexColor',
                order: 3,
              },
              accentPriceTextColor: {
                type: 'HexColor',
                order: 4,
              },
              textSize: {
                order: 5,
                type: 'RangePx',
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                },
              },
              priceTextSize: {
                order: 6,
                type: 'RangePx',
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                },
              },
              textWeight: {
                type: 'SelectBox',
                data: {
                  selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
                },
                order: 7,
              },
              priceTextWeight: {
                type: 'SelectBox',
                data: {
                  selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
                },
                order: 8,
              },
              iconWidth: {
                order: 9,
                data: {
                  max: 42,
                  min: 12,
                  step: 1,
                },
                type: 'RangePx',
              },
              barColor: {
                type: 'HexColor',
                order: 4,
              },
            },
          },
        },
      },
      Menu_FirstBoxSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'firstBoxSettings',
        },
        options: {
          firstBoxIcon: {
            type: 'IconSelector',
            data: {
              defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
            },
            order: 1,
          },
          firstText: {
            type: 'Text',
            order: 1,
          },
          firstPrice: {
            type: 'Text',
            order: 1,
          },
        },
      },
      Menu_SecondBoxSettings: {
        type: 'Menu',
        order: 200,
        renderOptions: {
          controlKey: 'secondBoxSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'secondBox',
            },
            options: {
              secondBoxIcon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 1,
              },
              secondText: {
                type: 'Text',
                order: 1,
              },
              secondPrice: {
                type: 'Text',
                order: 1,
              },
            },
          },
        },
      },
      Menu_ThirdBoxSettings: {
        type: 'Menu',
        order: 300,
        renderOptions: {
          controlKey: 'thirdBoxSettings',
        },
        options: {
          thirdBoxIcon: {
            type: 'IconSelector',
            data: {
              defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
            },
            order: 1,
          },
          thirdText: {
            type: 'Text',
            order: 1,
          },
          thirdPrice: {
            type: 'Text',
            order: 1,
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'CargoBar_1',
      name: 'CargoBar_1',
      type: 'CargoBar',
      data: {
        text: '',
        images: [],
      },
      customization: {
        isShowCargoBar: true,
        containerPadding: '5px 5px 5px 5px',
        firstBoxIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710501708_f7632609-9c15-454b-909b-67e1a01bcef2.png',
        secondBoxIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710501700_0874b0e5-ba59-4dcc-bd35-1ec1a86f1140.png',
        thirdBoxIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710501706_c1867201-63fe-490a-984f-3fe5b8ce96af.png',
        firstText: 'Ücretsiz Kargo',
        textColor: '#000000',
        accentPriceTextColor: '#FFA942',
        textSize: '10px',
        priceTextSize: '9px',
        textWeight: '400',
        priceTextWeight: '600',
        iconWidth: '40px',
        secondText: '%10 İndirim Kuponu',
        secondBox: true,
        barColor: '#000000',
        thirdText: 'Ayın Hediyesi',
        priceTextColor: '#000000',
        buttonTextColor: '#FFFFFF',
        buttonBackgroundColor: '#008001',
        firstPrice: '1000',
        secondPrice: '2000',
        thirdPrice: '3000',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Cart+1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};

export default CargoBar;
